<div class="dia-season-valor-container">
	<h2 class="title">{{ title }}</h2>
	<div [id]="ph_id" class="dia-season-valor-ph"></div>
</div>
